export const STATUS_DATA = [
  {
    id: '1',
    label: 'Aktif',
    value: true,
    name: 'optionStatus',
  },
  {
    id: '2',
    label: 'Tidak Aktif',
    value: false,
    name: 'optionStatus',
  },
];

export const STATUS_DATA_EN = [
  {
    id: '1',
    label: 'Active',
    value: true,
    name: 'optionStatus',
  },
  {
    id: '2',
    label: 'Not Active',
    value: false,
    name: 'optionStatus',
  },
];

export const STATUS_IOT = [
  {
    id: '1',
    label: 'Online',
    value: true,
    name: 'optionStatus',
  },
  {
    id: '2',
    label: 'Offline',
    value: false,
    name: 'optionStatus',
  },
];

export const STATUS_TOKEN = [
  {
    id: '1',
    label: 'Sudah Terisi',
    value: true,
    name: 'optionStatus',
  },
  {
    id: '2',
    label: 'Hampir Habis',
    value: false,
    name: 'optionStatus',
  },
];

export const KWH_DATA = [
  {
    id: '1',
    label: 'Pisah',
    value: 'PISAH',
    name: 'optionStatus',
  },
  {
    id: '2',
    label: 'Tidak Pisah',
    value: 'TIDAK_PISAH',
    name: 'optionStatus',
  },
];

export const KWAH_DATA = [
  {
    id: '1',
    label: 'Prabayar',
    value: 'PRABAYAR',
    name: 'optionStatus',
  },
  {
    id: '2',
    label: 'Pascabayar',
    value: 'PASCABAYAR',
    name: 'optionStatus',
  },
  {
    id: '3',
    label: 'Listrik Tempat',
    value: 'LISTRIK_TEMPAT',
    name: 'optionStatus',
  },
];

export const LIMIT_TABLE_DATA = 8;

export const FORMAT_TIME = 'DD MMMM YYYY - HH:mm';
export const FORMAT_DATE = 'DD MMMM YYYY';

export const ROLE_ID_AND_NAME_CONVENTION = {
  FACTORY: process.env.REACT_APP_ROLE_FACTORY,
  PERTAMINA: process.env.REACT_APP_ROLE_PERTAMINA,
  PLN: process.env.REACT_APP_ROLE_PLN,
  ARKADIA: process.env.REACT_APP_ROLE_ARKADIA,
  GENTARI: process.env.REACT_APP_ROLE_GENTARI,
  DEMO: process.env.REACT_APP_ROLE_DEMO,
};

export const ROLE_NAME_AND_ID_CONVENTION = {
  [parseInt(process.env.REACT_APP_ROLE_TECHNICIAN)]: 'TECHNICIAN',
  [parseInt(process.env.REACT_APP_ROLE_FACTORY)]: 'FACTORY',
  [parseInt(process.env.REACT_APP_ROLE_PERTAMINA)]: 'PERTAMINA',
  [parseInt(process.env.REACT_APP_ROLE_PLN)]: 'PLN',
  [parseInt(process.env.REACT_APP_ROLE_ARKADIA)]: 'ARKADIA',
  [parseInt(process.env.REACT_APP_ROLE_GENTARI)]: 'GENTARI',
  [parseInt(process.env.REACT_APP_ROLE_DEMO)]: 'DEMO',
};

export const SGB_TYPE = {
  REGULAR: 'REGULAR',
  PLN_SPBKLU_INTERCHANGEABLE: 'PLN_SPBKLU_INTERCHANGEABLE',
};
